<div class="faq-side-secton" [class.open]="openSidebar">
  <div class="faq-list-space" id="faq-sidebar">
    <ng-content></ng-content>
  </div>
  <button type="button" class="faq-toggle-icon" aria-controls="faq-sidebar"
    [attr.aria-expanded]="openSidebar" (click)="toggleSidebar();">
    @if (!openSidebar) {
      <i class="fas fa-question-circle"></i>
    }
    @if (openSidebar) {
      <i class="fas fa-caret-left"></i>
      }<br>
      <span>{{ 'LOGIN.FAQ-TOGGLE-TEXT' | translate }}</span>
    </button>
  </div>
